import vue from 'vue';

const itemClickEventBus = new vue();

export default itemClickEventBus;